<mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }" *ngIf="availableMods$ | async as available">
  <mat-label i18n>Тип</mat-label>
  <mat-select [(ngModel)]="mode" (selectionChange)="onModeChange()" [disabled]="!editable">
    <mat-option [value]="thisAngleMode.None">
      {{ thisAngleMode.None | angleProcessingName : withoutProcessingText }}
    </mat-option>
    <mat-option
      *ngIf="available.has(thisAngleMode.Rounded)"
      [value]="thisAngleMode.Rounded"
      [disabled]="hasDiagonalCutNeighbor()">
      {{ thisAngleMode.Rounded | angleProcessingName }}
    </mat-option>
    <mat-option
      *ngIf="available.has(thisAngleMode.RoundedInside)"
      [value]="thisAngleMode.RoundedInside"
      [disabled]="hasDiagonalCutNeighbor()">
      {{ thisAngleMode.RoundedInside | angleProcessingName }}
    </mat-option>
    <mat-option
      *ngIf="available.has(thisAngleMode.Cutted)"
      [value]="thisAngleMode.Cutted"
      [disabled]="hasDiagonalCutNeighbor()">
      {{ thisAngleMode.Cutted | angleProcessingName }}
    </mat-option>
    <mat-option
      *ngIf="available.has(thisAngleMode.DiagonalCut)"
      [value]="thisAngleMode.DiagonalCut"
      [disabled]="!validDiagonalCut()">
      {{ thisAngleMode.DiagonalCut | angleProcessingName }}
    </mat-option>
    <mat-option
      *ngIf="available.has(thisAngleMode.CuttedInsideWithAngle)"
      [value]="thisAngleMode.CuttedInsideWithAngle"
      [disabled]="hasDiagonalCutNeighbor()">
      {{ thisAngleMode.CuttedInsideWithAngle | angleProcessingName }}
    </mat-option>
    <mat-option
      *ngIf="available.has(thisAngleMode.CuttedInsideWithAngle)"
      [value]="thisAngleMode.CuttedInside"
      [disabled]="hasDiagonalCutNeighbor()">
      {{ thisAngleMode.CuttedInside | angleProcessingName }}
    </mat-option>
    <mat-option
      *ngIf="available.has(thisAngleMode.Chamfer)"
      [value]="thisAngleMode.Chamfer"
      [disabled]="hasDiagonalCutNeighbor()">
      {{ thisAngleMode.Chamfer | angleProcessingName }}
    </mat-option>
    <mat-option *ngIf="available.has(thisAngleMode.MasonsMitreMale)" [value]="thisAngleMode.MasonsMitreMale">
      {{ thisAngleMode.MasonsMitreMale | angleProcessingName }}
    </mat-option>
    <mat-option *ngIf="available.has(thisAngleMode.MasonsMitreFemale)" [value]="thisAngleMode.MasonsMitreFemale">
      {{ thisAngleMode.MasonsMitreFemale | angleProcessingName }}
    </mat-option>
  </mat-select>
</mat-form-field>
